module.exports = __webpack_public_path__ + "static/media/google-authenticator-2.7b6206ec.svg";